import styled from 'styled-components';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import BaseProductTier from './BaseProductTier';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductTierWrapper = styled.div.withConfig({
  displayName: "ProductTier__ProductTierWrapper",
  componentId: "sc-16aglko-0"
})([".product{width:50%;}", "{float:right;max-width:325px;margin-left:48px;margin-bottom:48px;width:50%;.product{width:100%;}.is--module{margin-bottom:0;}}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));
const ProductTier = props => {
  return /*#__PURE__*/_jsx(ProductTierWrapper, {
    children: /*#__PURE__*/_jsx(BaseProductTier, Object.assign({}, props))
  });
};
export default ProductTier;